import { dynamicschemaData } from "../../../shared/models/dynamic-schema-data";
import { Component, OnInit, OnDestroy,  } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { TemplateService } from "../../../shared/services/template.service";
import { Subscription } from "rxjs";


@Component({
  selector: 'app-dynamicforms',
  templateUrl: './dynamicforms.component.html',
  styleUrls: ['./dynamicforms.component.css']
})
export class DynamicformsComponent implements OnInit, OnDestroy {
  public form: FormGroup;
  valueChangesSubscription: Subscription;
  public fields: any={};
  public txt: string;
  constructor(private templateService: TemplateService) {
    this.fields = this.templateService.getTemplate().fields;
    this.txt = JSON.stringify(this.fields);
     this.form = new FormGroup({
       fields: new FormControl(this.txt)
     })
    this.valueChangesSubscription = this.form.valueChanges.subscribe((update) => {

      this.fields = JSON.parse(update.fields);
      });
  }

  onUpload(e) {
  }

  getFields() {
    return this.fields;
  }

  ngOnDestroy() {
    this.valueChangesSubscription.unsubscribe();
  }

  ngOnInit() {

  }


}
